import { useRef } from 'react';

import { ButtonProps } from '@chakra-ui/react';

import { Button } from '../reexport';

type SubmitButtonProps = ButtonProps;

export function SubmitButton({ ...props }: SubmitButtonProps) {
  const ref = useRef<HTMLButtonElement>(null);

  return <Button type='submit' {...props} ref={ref} />;
}
